export const clean = (t = "") => t.replace(/\s+/g, "").toLowerCase();
export const cleanUnderscore = (t = "") => t.replace(/\s+/g, "_").toLowerCase();
export const safeCqlValue = (v = "") => String(v).replace(/'/g, "''");

export const getBaseWfsParams = () => ({
  service: "WFS",
  version: "1.1.0",
  request: "GetFeature",
  outputFormat: "application/json",
  format_options: "callback:getJson",
  SrsName: "EPSG:4326",
});

export const buildStateParams = ({ country, state }) => {
  const p = getBaseWfsParams();

  const map = {
    1: "crop_distribution:India_State_Boundary2019",
    2: "crop_distribution:nigeria_state_boundary",
    3: "crop_distribution:eastafrica_state_boundary",
    4: "crop_distribution:egypt_state_boundary",
  };

  p.typeName = map[country.code];
  p.CQL_FILTER = `State_LGD IN (${state.code})`;
  return p;
};

export const buildDistrictParams = ({ country, state, city }) => {
  const p = getBaseWfsParams();

  if (country.code === 2) {
    p.typeName = `crop_distribution:nigeria_${clean(state.label)}_lga_boundary`;
    p.CQL_FILTER = `Subdt_LGD IN (${city.code})`; 
  } else {
    p.typeName = {
      1: "crop_distribution:India_District_Boundary2019",
      3: "crop_distribution:eastafrica_district_boundary",
      4: "crop_distribution:Egypt_District_Boundary2019",
    }[country.code];
    p.CQL_FILTER = `Dist_LGD IN (${city.code})`;
  }

  p.selectValue = city.code;
  return p;
};

export const buildTalukaParams = ({ country, state, taluka }) => {
  const p = getBaseWfsParams();

  if (country.code === 2) {
    p.typeName = `crop_distribution:nigeria_${clean(state.label)}_lga_ward_boundary`;
    p.CQL_FILTER = `VILLAGE_CO IN (${taluka.code})`; 
  } else {
    p.typeName = {
      1: "crop_distribution:India_Sub_District_Boundary2019",
      3: "crop_distribution:eastafrica_subdistrict_boundary",
      4: "crop_distribution:Egypt_Sub_District_Boundary2019",
    }[country.code];
    p.CQL_FILTER = `Subdt_LGD IN (${taluka.code})`;
  }

  p.selectValue = taluka.code;
  return p;
};

export const buildVillageParams = ({
  country,
  state,
  village,
  featureType,
}) => {
  const p = getBaseWfsParams();

  p.typeName =
    country.code === 1
      ? state.code === 9 && featureType === "farmer-scorecard"
        ? "crop_distribution:india_uttarpradesh_village"
        : `crop_distribution:2023_india_${cleanUnderscore(
            state.label
          )}_village_boundary`
      : country.code === 2
      ? `crop_distribution:nigeria_${clean(state.label)}_village_boundary`
      : country.code === 3
      ? "crop_distribution:eastafrica_village_boundary"
      : `crop_distribution:2023_egypt_${cleanUnderscore(
          state.label
        )}_village_boundary`;

  p.CQL_FILTER = `Agbr_co IN ('${safeCqlValue(village.code)}')`;
  p.selectValue = `0${village.code}`;
  return p;
};

const getIndiaCadastralLayer = ({ state, city, taluka }) => {
  const map = {
    9: "crop_distribution:india_uttarpradesh_cadestral",
    27: "crop_distribution:india_maharashtra_cadestral",
    33: "crop_distribution:india_tamilnadu_cadestral",
    21: "crop_distribution:india_odisha_cadestral"
  };

  return (
    map[state.code] ||
    `crop_distribution:india_${clean(state.label)}_${clean(
      city.label
    )}_${clean(taluka.label)}_cadestral`
  );
};

const getCadastralLayer = ({ country, state, city, taluka }) => {
  switch (country.code) {
    case 1:
      return getIndiaCadastralLayer({ state, city, taluka });
    case 2:
      return `crop_distribution:nigeria_${clean(state.label)}_${clean(
        city.label
      )}_${clean(taluka.label)}_cadestral`;
    case 3:
      return "crop_distribution:eastafrica_cadastral";
    case 4:
      return "crop_distribution:egypt_cadastral";
    default:
      return null;
  }
};

export const buildKhasraParams = ({
  country,
  state,
  city,
  taluka,
  village,
  khasra,
}) => {
  const p = getBaseWfsParams();

  p.typeName = getCadastralLayer({ country, state, city, taluka });
  p.CQL_FILTER = `
    Agbr_co IN ('${safeCqlValue(village.code)}')
    AND KHASRA IN ('${safeCqlValue(khasra.label)}')
  `;
  p.selectValue = `0${village.code}`;
  return p;
};

export const resolveOwsParamsByLevel = (ctx) => {
  const { city, taluka, village, khasra } = ctx;

  if (!city) return buildStateParams(ctx);
  if (!taluka) return buildDistrictParams(ctx);
  if (!village) return buildTalukaParams(ctx);
  if (!khasra) return buildVillageParams(ctx);

  return buildKhasraParams(ctx);
};


